export default {"src":"/_next/static/media/inline-skaten.045bd434.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};